import { createReducer, on } from '@ngrx/store';
import * as fromPaymentsActions from '../actions';
import { IRollbackPaymentRunResponse } from '../models/rollback-payment-run-response.model';

export const rollbackPaymentRunFeatureKey = 'rollbackPaymentRun';

export interface RollbackPaymentRunState {
  success: IRollbackPaymentRunResponse | null;
  failure: any | null;
  loading: boolean;
}

export const initialState: RollbackPaymentRunState = {
  success: null,
  failure: null,
  loading: false
};

export const rollbackPaymentRunReducer = createReducer(
  initialState,
  on(fromPaymentsActions.rollbackPaymentRun, state => ({
    ...state,
    success: null,
    failure: null,
    loading: true
  })),
  on(fromPaymentsActions.rollbackPaymentRunSuccess, (state, { response }) => ({
    ...state,
    success: response,
    failure: null,
    loading: false
  })),
  on(fromPaymentsActions.rollbackPaymentRunFailure, (state, { error }) => ({
    ...state,
    success: null,
    failure: error,
    loading: false
  }))
);
